// PostDetail.js
'use client';
import { connect } from 'react-redux';

import { SUBSCRIPTION_CURRENCY } from '../RemoteConfigKeys.js';

import PostDetail from '../page/PostDetail.jsx';
import withRouter from '../component/WithRouter.jsx';

import getMeData from '../selector/getMeData.js';
import getMessageDataWithVariable, {
  VariableName,
} from '../selector/getMessageDataWithVariable.js';
import getUserData from '../selector/getUserData.js';
import getMessageData from '../selector/getMessageData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getNetworkingSummary from '../selector/getNetworkingSummary.js';

import fetchMessageDetail from '../action/fetchMessageDetail.js';
import fetchUser from '../action/fetchUser.js';
import fetchMessageRating from '../action/fetchMessageRating.js';
import fetchDiamondPacks from '../action/fetchDiamondPacks.js';

import { ProductType, SHOP_ID } from '../resource/shopConstants.js';

const mapStateToProps = (
  state,
  { messageId: propsMessageId, match, location }
) => {
  const chatroomId = match?.params?.chatroomId;
  const messageId = propsMessageId || match?.params?.messageId;
  const senderId = getMessageData(state, messageId, 'senderId');
  const defaultSubscriptionCurrency = getRemoteConfigData(
    state,
    SUBSCRIPTION_CURRENCY
  );
  const meUsername = getMeData(state, 'username');
  return {
    chatroomId,
    messageId,
    title: getMessageDataWithVariable(
      state,
      messageId,
      'title',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    senderName: getUserData(state, senderId, 'username'),
    senderId,
    defaultSubscriptionCurrency,
    deviceWidth: getOperationData(state, ['device'], 'width'),
    isSubscriptionProductFetched: getNetworkingData(
      state,
      [
        'shop',
        SHOP_ID.subscription,
        defaultSubscriptionCurrency,
        ProductType.SUBSCRIPTIONS,
        senderId,
      ],
      'isFetched'
    ),
    shouldShowChatroomMediaLibrary:
      location?.state?.shouldShowChatroomMediaLibrary,
    shouldFetchMessageTranslation: true, // For withFetchTranslation
    detailError: getNetworkingSummary(state, ['messages', messageId, 'detail'])
      ?.error,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchMessageDetail: ({ messageId, httpProxyHeaders }) =>
      dispatch(fetchMessageDetail({ id: messageId, httpProxyHeaders })),
    fetchUser: ({ id, httpProxyHeaders }) =>
      dispatch(fetchUser({ id, httpProxyHeaders })),
    fetchDiamondPacks: ({
      currency,
      shopId,
      type,
      productIds,
      httpProxyHeaders,
    }) =>
      dispatch(
        fetchDiamondPacks({
          currency,
          shopId,
          type,
          productIds,
          httpProxyHeaders,
        })
      ),
    fetchRating: ({ id }) => dispatch(fetchMessageRating({ id })),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PostDetail)
);
